module.exports = __webpack_public_path__ + "fonts/CashSans-Medium.6340fc6.woff2";